import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import c from 'classnames';
import { ActionBarDialogContext } from '../../../ActionBarContext';
import PopoverWithTooltip from '../../../../Popover/Preset/PopoverWithTooltip';
import s from './ActionBarItemWrapper.scss';
/**
 * Wraps any item we're going to place on the ActionBar. It provides a popover tooltip.
 *
 * e.g.
 * ```
 * <ActionBarItemWrapper tooltip="Hello World">
 *   <ActionBarButton href="...">
 *     <Icon />
 *   </ActionBarButton>
 * </ActionBarItemWrapper>
 * ```
 */ const ActionBarItemWrapper = (_param)=>{
    var { allowMobilePopover, className, popoverWrapperClassName, forceVisibleTooltip } = _param, rest = _object_without_properties(_param, [
        "allowMobilePopover",
        "className",
        "popoverWrapperClassName",
        "forceVisibleTooltip"
    ]);
    const isAnyDialogOpen = useContext(ActionBarDialogContext);
    return /*#__PURE__*/ React.createElement(PopoverWithTooltip, _object_spread({
        allowMobile: allowMobilePopover,
        isDisabled: isAnyDialogOpen,
        contentClassName: s['popover'],
        wrapperClassName: c(s['root-wrapper'], className),
        referenceClassName: c(s['popover-wrapper'], popoverWrapperClassName),
        forceVisibleTooltip: forceVisibleTooltip
    }, rest));
};
ActionBarItemWrapper.displayName = 'ActionBarItemWrapper';
export default ActionBarItemWrapper;
